import { TooltipProps } from 'recharts';
import { DepthData } from '../../lib/depthDataHelpers';
import { formatDollar, formatNumber, formatPercentage } from '../../lib/formatters';
import { Gwei } from '../../lib/gwei';
import { PrettyMerge } from '../../lib/tsUtilityTypes';

type DepthChartTooltipProps = PrettyMerge<
  TooltipProps<number, string>,
  {
    payload?: Array<{
      payload: PrettyMerge<
        DepthData,
        { depth: number; price: number; totalCost: number; priceImpact: number }
      >;
      // Include other properties that might be in the payload
      color?: string;
      dataKey?: string | number;
      name?: string;
      value?: number | string;
    }>;
    priceDecimals: number;
  }
>;
export const DepthChartTooltip: React.FC<DepthChartTooltipProps> = ({
  active,
  payload,
  priceDecimals,
}) => {
  const firstPayload = payload?.[0];
  if (active && firstPayload) {
    const data = firstPayload.payload;

    return (
      <div className="w-[200px] rounded bg-backgroundPrimary p-2 text-contentSecondary">
        <div>
          <p
            className={`mb-2 flex justify-between text-xs ${data.type === 'bid' ? 'text-contentGreen' : 'text-contentRed'}`}
          >
            {data.type === 'bid' ? 'Bids' : 'Asks'}
          </p>
          <div className="flex flex-col flex-wrap gap-2 text-3xs">
            <div className="flex justify-between">
              <span className="text-contentSecondary">Price</span>
              <span className="text-contentPrimary">
                {data.type === 'bid' ? '≥' : '≤'}{' '}
                {formatDollar(Gwei.toGwei(data.price), {
                  maximumFractionDigits: priceDecimals,
                  minimumFractionDigits: priceDecimals,
                })}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-contentSecondary">Total Size</span>
              <span className="text-contentPrimary">{formatNumber(Gwei.toGwei(data.depth))}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-contentSecondary ">Total Cost</span>
              <span className="text-contentPrimary">
                ${formatNumber(Gwei.toGwei(data.totalCost))}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-contentSecondary ">Price Impact</span>
              <span className="text-contentPrimary">
                {formatPercentage(Gwei.toGwei(data.priceImpact))}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};
